import type { BetterstartIntegrationDefinition } from '@cli-types/integration-engine/integrations.js'

export const mailchimpIntegration: BetterstartIntegrationDefinition = {
  id: 'mailchimp',
  title: 'Mailchimp',
  description: 'Mailchimp audience sync for form submissions',
  kind: 'form',
  version: '1.0.0',
  dependencies: [],
  conflicts: [],
  files: [
    {
      outputPath: 'lib/actions/mailchimp/add-to-mailchimp-audience.ts',
      templatePath: 'actions/mailchimp.ts'
    }
  ],
  packageDependencies: ['@mailchimp/mailchimp_marketing'],
  devDependencies: ['@types/mailchimp__mailchimp_marketing'],
  capabilities: {
    formFeatures: ['mailchimp']
  },
  envSections: [
    {
      header: 'Mailchimp',
      vars: [
        { key: 'BETTERSTART_MAILCHIMP_API_KEY', value: '' },
        { key: 'BETTERSTART_MAILCHIMP_SERVER_PREFIX', value: '' },
        { key: 'BETTERSTART_MAILCHIMP_AUDIENCE_ID', value: '' }
      ]
    }
  ],
  configure: 'none'
}
